/*
Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry
*/
import React from 'react';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import Block from '../../../block/Block';
import WellsFargoLogo from '../../../icons/wells-fargo-logo/WellsFargoLogo';
import ThePrivateBankLogo from '../../../icons/tpb-logo-icon/ThePrivateBankLogo';
import LogoLink from '../../logo-link/LogoLink';
import useBrand from '../../../hooks/use-brand';
import useDevice from '../../../hooks/use-device';
import useWindowScrollPosition from '../../../hooks/use-window-scroll-position';
import styles from './TPBAnimatingNavigationLogo.less';
var SCROLL_DISTANCE = 150;

var TPBAnimatingNavigationLogo = function TPBAnimatingNavigationLogo(_ref) {
  var navigationDisabled = _ref.navigationDisabled,
      handleClick = _ref.handleClick,
      _ref$logoAltText = _ref.logoAltText,
      logoAltText = _ref$logoAltText === void 0 ? 'Wells Fargo' : _ref$logoAltText;
  var brand = useBrand();
  var device = useDevice();

  var _useWindowScrollPosit = useWindowScrollPosition(),
      scrollTop = _useWindowScrollPosit.y;

  var containerClassNames = getClasses({
    styles: styles,
    classes: ['container', scrollTop > SCROLL_DISTANCE && 'collapsed'],
    device: device
  });
  var logoClassNames = getClasses({
    styles: styles,
    classes: ['logo'],
    brand: brand
  });
  var wfClassNames = getClasses({
    styles: styles,
    classes: ['transitionLogo']
  });
  var tpbClassNames = getClasses({
    styles: styles,
    classes: ['transitionLogo', 'tpb']
  });

  var onClick = function onClick(event) {
    !navigationDisabled && handleClick(event);
  };

  return brand !== 'dc' ? /*#__PURE__*/React.createElement(Block, {
    layout: true,
    flex: true,
    centered: device.isMobile(),
    className: containerClassNames
  }, /*#__PURE__*/React.createElement(Block, {
    className: wfClassNames
  }, /*#__PURE__*/React.createElement(LogoLink, {
    handleClick: onClick
  }, /*#__PURE__*/React.createElement(WellsFargoLogo, {
    title: "".concat(logoAltText, " - The Private Bank"),
    className: logoClassNames
  }))), /*#__PURE__*/React.createElement(Block, {
    className: tpbClassNames
  }, /*#__PURE__*/React.createElement(LogoLink, {
    handleClick: onClick
  }, /*#__PURE__*/React.createElement(ThePrivateBankLogo, {
    className: logoClassNames,
    reversed: true
  })))) : null;
};

export default TPBAnimatingNavigationLogo;